
































































import Vue from "vue";
import Component from "vue-class-component";
import { Section as SectionInterface } from "../../services/section/entities/section.interface";
import Divider from "../common/Divider.vue";
import constants from "../../config/constants";

@Component({
  components: {
    Divider
  }
})
export default class DynamicSections extends Vue {
  private created(): void {
    this.$store.dispatch("section/getSectionsToClient");
  }

  private get sections(): Array<SectionInterface> {
    const sections = this.$store.getters["section/getSections"];

    const result = sections.filter(
      (section: SectionInterface) =>
        section.sectionStatus == constants.STATUS.ACTIVE
    );
    return result;
  }
}
